import { WifiOff } from "lucide-react";

const NoInternet = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-[9999]">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, rgb(0,0,0) 1px, transparent 0)`,
            backgroundSize: "24px 24px",
          }}
        ></div>
      </div>

      {/* Main content container */}
      <div className="relative text-center px-6 py-8 max-w-lg mx-auto">
        {/* Icon container */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-50 rounded-2xl border border-gray-100 shadow-sm">
            <WifiOff className="w-8 h-8 text-gray-400" strokeWidth={1.5} />
          </div>
        </div>

        {/* Main heading */}
        <h1 className="text-2xl font-medium text-gray-900 mb-3 tracking-tight">
          No internet connection
        </h1>

        {/* Description */}
        <p className="text-gray-500 text-base mb-8 leading-relaxed max-w-sm mx-auto">
          Please check your network settings and try connecting again.
        </p>

        {/* Connection status */}
        <div className="flex items-center justify-center gap-2 mt-8 text-sm text-gray-400">
          <div className="w-1.5 h-1.5 bg-red-400 rounded-full"></div>
          <span className="font-medium">Offline</span>
        </div>
      </div>
    </div>
  );
};

export default NoInternet;
